import { render, staticRenderFns } from "./ProductInfoSupplyChain.vue?vue&type=template&id=d2e50532&"
import script from "./ProductInfoSupplyChain.vue?vue&type=script&lang=js&"
export * from "./ProductInfoSupplyChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports